
import employee_work_life_balance from "../../../assets/images/asean/employee_work_life_balance.webp";
import employee_multinational from "../../../assets/images/asean/employee_multinational.webp";
import employee_comprehensive from "../../../assets/images/asean/employee_comprehensive.webp";
import employee_extensive from "../../../assets/images/asean/employee_community.webp";
import employee_career_opportunities from "../../../assets/images/asean/employee_career_opportunities.webp";
import employee_thrilling from "../../../assets/images/asean/employee_thrilling.webp";


export const ASEAN_EMPLOYEE_LOVES_STATIC = [{
    id: 1,
    src: employee_work_life_balance,
    title: "page.asea.employee_love_1",
    description: "page.asea.employee_love_1_description"
}, {
    id: 2,
    src: employee_multinational,
    title: "page.asea.employee_love_2",
    description: "page.asea.employee_love_2_description"
}, {
    id: 3,
    src: employee_comprehensive,
    title: "page.asea.employee_love_3",
    description: "page.asea.employee_love_3_description"
}, {
    id: 4,
    src: employee_extensive,
    title: "page.asea.employee_love_4",
    description: "page.asea.employee_love_4_description"
}, {
    id: 5,
    src: employee_career_opportunities,
    title: "page.asea.employee_love_5",
    description: "page.asea.employee_love_5_description"
}, {
    id: 6,
    src: employee_thrilling,
    title: "page.asea.employee_love_6",
    description: "page.asea.employee_love_6_description"
}];

export const ASEAN_EMPLOYEE_LOVES_STATIC_MOBILE = [{
    id: 1,
    mobile_items: [{
        id: 1,
        src: employee_work_life_balance,
        title: "page.asea.employee_love_1",
        description: "page.asea.employee_love_1_description"
    }, {
        id: 2,
        src: employee_multinational,
        title: "page.asea.employee_love_2",
        description: "page.asea.employee_love_2_description"
    }]
},
{
    id: 2,
    mobile_items: [{
        id: 3,
        src: employee_comprehensive,
        title: "page.asea.employee_love_3",
        description: "page.asea.employee_love_3_description"
    }, {
        id: 4,
        src: employee_extensive,
        title: "page.asea.employee_love_4",
        description: "page.asea.employee_love_4_description"
    }]
},
{
    id: 3,
    mobile_items: [{
        id: 5,
        src: employee_career_opportunities,
        title: "page.asea.employee_love_5",
        description: "page.asea.employee_love_5_description"
    }, {
        id: 6,
        src: employee_thrilling,
        title: "page.asea.employee_love_6",
        description: "page.asea.employee_love_6_description"
    }]
}
];